import api from "@modules/api/api";
import { useMutation } from "@tanstack/react-query";
import { CreatePrivateBillOfSaleRequest } from "../types/CreatePrivateBillOfSaleRequest";
import { CreatePrivateBillOfSaleResponse } from "../types/CreatePrivateBillOfSaleResponse";

const postCreateDealCustomer = async (
  createPrivateBillOfSaleRequest: CreatePrivateBillOfSaleRequest
): Promise<CreatePrivateBillOfSaleResponse | undefined> => {
  if (
    !createPrivateBillOfSaleRequest.privateBillOfSaleDetails.vehicleInformation
      .vin
  ) {
    return undefined;
  }

  return api.post<CreatePrivateBillOfSaleResponse>(
    "api/private-bill-of-sales",
    {
      json: createPrivateBillOfSaleRequest,
      headers: { "Accept-Language": createPrivateBillOfSaleRequest.locale },
    }
  );
};

export default function useCreatePrivateBillOfSaleMutation() {
  return useMutation({ mutationFn: postCreateDealCustomer });
}
